import * as React from "react";
import type { SVGProps } from "react";
const SvgBamse = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 87 77" {...props}>
    <path
      d="M2189 322a14.03 14.03 0 0 0-13.98-14 14.22 14.22 0 0 0-10.99 5.3 37.8 37.8 0 0 0-17.08-4.1 36.84 36.84 0 0 0-19.18 5.3 13.83 13.83 0 0 0-11.79-6.5 14.03 14.03 0 0 0-13.98 14 13.875 13.875 0 0 0 9.09 13.1 36.8 36.8 0 0 0-2 12 37.855 37.855 0 1 0 75.71 0 39.2 39.2 0 0 0-2.39-13.3A13.61 13.61 0 0 0 2189 322m-58.93 31.6c-1.8 0-3.2-1.9-3.2-4.2s1.4-4.2 3.2-4.2 3.19 1.9 3.19 4.2-1.4 4.2-3.19 4.2m24.67 17.3a11.8 11.8 0 0 1-3.8.8 5.5 5.5 0 0 1-3.39-1.1.7.7 0 1 0-1.4 0 4.81 4.81 0 0 1-3.4 1.1 11.7 11.7 0 0 1-3.79-.8 1.235 1.235 0 0 1 .9-2.3c1.49.6 3.59 1 4.69.1a3.8 3.8 0 0 0 1-2.6v-1.5c-2.5-.5-4.3-2.2-4.3-4.3 0-2.5 2.6-4.5 5.8-4.5s5.79 2 5.79 4.5c0 2.2-2.1 4-4.79 4.4v1.4a3.87 3.87 0 0 0 .99 2.5c1.1.9 3.2.5 4.7-.1a1.305 1.305 0 0 1 1.6.7 1.208 1.208 0 0 1-.6 1.7m7.29-16.8c-1.8 0-3.2-1.9-3.2-4.2s1.4-4.2 3.2-4.2 3.2 1.9 3.2 4.2c.1 2.3-1.4 4.2-3.2 4.2"
      style={{
        fill: "currentColor",
        fillRule: "evenodd",
      }}
      transform="translate(-2102 -308)"
    />
  </svg>
);
export default SvgBamse;
